import React, { useEffect, useState } from 'react'
import NewPrintButtonClick from './NewPrintButtonClick'
import NewPackageDownloadPdf from '../../../ButtonToDownload/NewPackageDownloadPdf';
import { pdf } from '@react-pdf/renderer';
import logo from "../../../../assets/images/Mountain-mystries-logo.png";
import { getDecryptedData } from '../../../../utils/crypto';
import { SvgPrint } from '../../../../utils/svgIcons';

const NewUIPackagePrint = ({
    packageData,
    selectedCategory,
    allPackageHotels,
    selectedMealPlan
}) => {
    const [markupData, setMarkupData] = useState(null);
    const userType = localStorage.getItem("userType");
    const token = getDecryptedData("userToken");
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const agent_selected_id = JSON.parse(localStorage.getItem("userDetails"));
    const [selectedOption, setSelectedOption] = useState("newMarkup");
    const [markupValue, setMarkupValue] = useState(0);
    const [imageData, setImageData] = useState(null);
    const [isDownloading, setIsDownloading] = useState(false);

    const calculatePriceWithMarkup = (
        basePrice
        // additionalMarkup = 0,
        // additionalMarkupType = "percentage"
    ) => {
        if (!markupData) return basePrice;

        let additionalMarkupType = "percentage";
        let additionalMarkup = markupValue;

        const { markupType, amount } = markupData;
        let finalPrice = basePrice;

        if (markupType === "percentage") {
            const percentageAmount = (parseFloat(amount) / 100) * basePrice;
            finalPrice += percentageAmount;
        } else if (markupType === "fixed") {
            finalPrice += parseFloat(amount);
        }

        if (
            !additionalMarkup ||
            additionalMarkup === "" ||
            additionalMarkup === "0" ||
            additionalMarkup === "0.0" ||
            additionalMarkup === 0 ||
            additionalMarkup === null ||
            additionalMarkup === undefined
        ) {
            return finalPrice;
        }

        // Apply additional markup
        if (additionalMarkupType === "percentage") {
            const additionalPercentageAmount =
                (parseFloat(additionalMarkup) / 100) * finalPrice;
            finalPrice += additionalPercentageAmount;
        } else if (additionalMarkupType === "fixed") {
            finalPrice += parseFloat(additionalMarkup);
        }

        return finalPrice;
    };

    const fetchMedia = async (agentToken) => {
        const myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", `Bearer ${agentToken}`);
        myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

        const formdata = new FormData();
        formdata.append("modelType", "agents");
        formdata.append("modelId", agent_selected_id?.id);
        formdata.append("upload_collection", "agent-logo");

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow",
        };

        try {
            const response = await fetch(
                `${process.env.REACT_APP_BASE_URL}/api/v1/website/agent/file/fetch`,
                requestOptions
            );
            const result = await response.json();
            if (result.success) {
                setImageData(result?.data);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const fetchMarkup = async () => {
        const myHeaders = new Headers();
        myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
        myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow",
        };

        fetch(
            `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/markups`,
            requestOptions
        )
            .then((response) => response.json())
            .then((result) => {
                if (result.success) {
                    const findObject = result?.data?.find(
                        (mark) => mark?.markupCustomer === "both"
                    );
                    // console.log("findObject", findObject);

                    if (findObject) {
                        setMarkupData(findObject);
                    } else {
                        setMarkupData(null);
                    }
                } else {
                    setMarkupData("No data found");
                }
            })
            .catch((error) => console.error(error));
    };

    useEffect(() => {
        fetchMarkup();
    }, []);

    useEffect(() => {
        if (token && userType === "agent") {
            fetchMedia(token);
        }
    }, [token]);

    const fetchImageAsBase64 = async (imageUrl) => {
        if (!imageUrl || typeof imageUrl !== "string") {
            console.error("fetchImageAsBase64: Invalid image URL:", imageUrl);
            return null;
        }

        try {
            const response = await fetch(imageUrl, {
                mode: "cors",
                cache: "no-store",
            });

            if (!response.ok) {
                console.error(
                    "fetchImageAsBase64: Failed to fetch image",
                    response.statusText
                );
                return null;
            }

            const blob = await response.blob();

            return await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = () => reject("FileReader failed");
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error("fetchImageAsBase64: Error occurred", error);
            return null;
        }
    };

    const printPDF = async () => {
        setIsDownloading(true);
        const logoBase64 = await fetchImageAsBase64(imageData || "");

        const destinationImages = await Promise.all(
            packageData?.packageDestination?.map(dest =>
                fetchImageAsBase64(dest?.image)
            ) || []
        );

        const hotelsWithImages = await Promise.all(
            allPackageHotels?.map(async (hotel) => {
                const featuredImageBase64 = await fetchImageAsBase64(hotel?.featuredImage);
                return {
                    ...hotel,
                    base64FeaturedImage: featuredImageBase64 || hotel?.featuredImage
                };
            }) || []
        );

        try {
            const blob = await pdf(
                <NewPackageDownloadPdf
                    // packageData={packageData}
                    packageData={{
                        ...packageData,
                        packageDestination: packageData?.packageDestination?.map((dest, index) => ({
                            ...dest,
                            base64Image: destinationImages[index]
                        }))
                    }}
                    imageData={logoBase64}
                    logo={logo}
                    userDetails={userDetails}
                    userType={userType}
                    selectedCategory={selectedCategory}
                    allPackageHotels={hotelsWithImages}
                    calculatePriceWithMarkup={calculatePriceWithMarkup}
                    selectedOption={selectedOption}
                    additionalMarkup={markupValue}
                    selectedMealPlan={selectedMealPlan}
                />).toBlob();
            const url = URL.createObjectURL(blob);

            // Open the PDF in a new tab
            const newTab = window.open(url, '_blank');

            // Wait for the new tab to load and trigger print
            newTab.onload = () => {
                // Wait a bit to ensure the new tab content is ready
                setTimeout(() => {
                    newTab.print();
                    URL.revokeObjectURL(url); // Clean up URL after printing
                }, 1000); // Adjust the delay as needed
            };
        } catch (error) {
            console.error('Error generating PDF or printing:', error);
        } finally {
            setIsDownloading(false); // Stop loading regardless of success/failure
        }
    };

    return (
        <>
            {/* <NewPrintButtonClick
      itemToDownloadID={"package-details"}
      // longPdf={true}
    /> */}
            <div
                onClick={printPDF}
                className="cursor_pointer flex align_items_center flex_direction_col"
            >
                <span>
                    <SvgPrint color={"#009A50"} />
                </span>

                {/* <span className="color_333">Print</span> */}

                {isDownloading ? (
                    <>
                        <span>Printing...</span>
                    </>
                ) : (
                    <span className="color_333">Print</span>
                )}
            </div>
        </>
    )
}

export default NewUIPackagePrint
